/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoCheckbox implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            name: "@",
            id: "@",
            currentValue: "=ngModel",
            contentKey: "@",
            contentValues: "<?",   // optional translate-values for the label, e.g. a currency-formatted amount; opt-in so other checkboxes keep their one-time label
            disabled: "=ngDisabled",
            negateValue: "@",
            showLabelOnTop: "=",
            tabIndex: "@?",
            theme: "=?ngClass",
            preCallback: "&?",
            callback: "&?",
            defaultValue: "=?",
            circularAppearance: "=?",
            cache: '=?',
            indeterminate: '=?'
        };

        templateUrl = "app/components/controls/checkboxTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.cache = typeof scope.cache === 'boolean' ? scope.cache : true;

            if(!!scope.theme)
                scope.clas = scope.theme;

            scope.toggleValue = ($event): void => {
                let proceed = true;
                if (scope.preCallback) {
                    proceed = scope.preCallback();
                }
                if (proceed) {
                    if ($event.charCode != 32) {
                        scope.currentValue = !scope.currentValue;
                    }

                    if (scope.callback) {
                        this.$timeout(() => scope.callback(), 0);
                    }
                }
            };

            // Setup Variable
            if (scope.defaultValue && !scope.currentValue) {
                scope.currentValue = scope.defaultValue
            } else if (scope.currentValue == undefined) {
                scope.currentValue = false;
            }

            if (!angular.isDefined(scope.tabIndex)) {
                scope.tabIndex = 0;
            }

            var previousTabIndex = scope.tabIndex;
            scope.$watch('disabled', function (newValue, oldValue) {
                if (newValue) {
                    previousTabIndex = scope.tabIndex;
                    scope.tabIndex = -1;
                } else {
                    scope.tabIndex = previousTabIndex;
                }
            }, true);
        };

        constructor(protected $timeout) {}

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => {
                return new MeevoCheckbox($timeout);
            };

            directive.$inject = ['$timeout'];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoCheckbox", MeevoCheckbox.factory());
}
